import { gtag } from "~/lib/gtag";
export function subscribeExperiments(callback) {
  gtag("event", "optimize.callback", {
    callback
  });
}
export function unsubscribeExperiments(callback) {
  gtag("event", "optimize.callback", {
    callback,
    remove: true
  });
}